<template>
    <span v-if="client !== {}" :id="elemId">
        <b-link
            v-if="
                useRouter &&
                client.encoded_id &&
                !isNoOwner &&
                !noUrl &&
                businessActorActive
            "
            :to="{ name: 'client_profile', params: { id: client.encoded_id } }"
            :target="openNew ? '_blank' : '_self'"
            >{{ name }}</b-link
        >
        <a
            v-else-if="!useRouter && client.ci_url && !isNoOwner && !noUrl"
            :href="client.ci_url || '#'"
            :target="openNew ? '_blank' : '_self'"
            >{{ name }}
        </a>
        <span v-else>
            {{ name }}
        </span>

        <span v-if="!businessActorActive">
            (Deleted)
        </span>
        <span v-else-if="client.status === 2">
            (Inactive)
        </span>
        <span v-else-if="client.status === 3">
            (Deceased)
        </span>

        <b-popover
            v-if="showPopover"
            triggers="hover"
            :placement="popoverPlacement"
            :target="elemId"
            :delay="{ hide: 400 }"
        >
            <template v-slot:title>{{ name }}</template>
            <slot />
        </b-popover>
        <input
            type="hidden"
            name="client-id"
            :value="client.id ? client.id : ''"
        />
    </span>
</template>

<script>
/**
 * @module ClientName
 * @description Display name and status of client and as a link
 */
export default {
    name: "clientName",
    props: {
        client: {
            type: Object,
            required: true,
            default: () => {}
        },
        /**
         * text: label shown. if not specified, client.label will be used
         */
        text: {
            type: String,
            default: null
        },
        /**
         * useRouter: true = use react router push, false = use native anchor href
         */
        useRouter: {
            type: Boolean,
            default: true
        },
        showPopover: {
            type: Boolean,
            default: false
        },
        openNew: {
            type: Boolean,
            default: false
        },
        noUrl: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        popoverPlacement() {
            return window.innerWidth <= 768 ? "auto" : "right";
        },
        elemId() {
            return `client-name-link-${this.client.id}`;
        },
        name() {
            return (
                this.text ||
                this.client.label ||
                this.client.name ||
                this.firstLastName
            );
        },
        firstLastName() {
            if (this.client.firstname && this.client.lastname) {
                return this.client.firstname + " " + this.client.lastname;
            }
            return "";
        },
        isNoOwner() {
            if (_.isEmpty(this.client)) {
                return true;
            } else {
                let label = _.get(this.client, "label", null);
                let index = _.get(this.client, "index", false);

                if (index == 1) {
                    return true;
                } else if (label) {
                    return label.replace(" ", "").toUpperCase() == "NOOWNER";
                }
            }

            return false;
        },
        // If null/empty means from in barramundi,tbl_business_actor not found,
        // if undefined, barramundi not send this property hence, default to true
        businessActorActive() {
            if (typeof this.client.single_business_actor !== "undefined") {
                return this.client.single_business_actor
                    ? this.client.single_business_actor.isactive === true
                    : false;
            }
            return true;
        }
    }
};
</script>
